module.exports = __webpack_public_path__ + "assets/vehicle-unlocked.14dc7fee.svg";